<template>
  <v-card>
    <v-card-title class="mb-3">
      {{ labels.pulse }}
    </v-card-title>
    <v-card-text>
      <div class="definition-card-container">
        <p>
          Pulse AI is a revolutionary algorithm designed to identify anomalies
          in media reporting to compute daily micro-changes in risk and
          stability. The algorithm uses Risk Ratings to establish a baseline
          score, then adjusts that score based on seasonal activity in media
          reporting. Pulse scores can be used as indicators to alert users to
          actions that may pose a risk or present an opportunity to their
          operation. Pulse AI triggered alerts notify analysts of important
          developments, speed the process of finding and accessing
          mission-relevant data, and enable analysts to maintain situational
          awareness.
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { LABELS } from "@/common/constants/labels";

export default {
  name: "StabilityDescriptionV2",
  components: {},
  data() {
    return {
      labels: LABELS,
    };
  },
};
</script>
